<template>
  <div class="text-center" v-if="$apollo.queries.getGeofencebyId.loading">
    <b-spinner variant="danger" label="Spinning">Cargando</b-spinner>
  </div>
</template>
<script>
import gql from 'graphql-tag'
import headers from '@/config/headers.js'
const GET_GEOFENCE_BY_ID = gql`
query getGeofencebyId($id: Int) {
  getGeofencebyId(id: $id) {
    id
    name
    geofencePoint{
      lat
      lng
    }
  }
}
`
export default {
  props: {
    google: {
      type: Object,
      required: true,
    },
    map: {
      type: Object,
      required: true,
    },
  },
  methods: {
    drawGeofence(geofencePoints) {
      const { Polygon } = this.google.maps
      const geofence = new Polygon({
        path: geofencePoints,
        strokeColor: '#FF0000',
        strokeOpacity: 0.8,
        strokeWeight: 3,
        fillColor: '#FF0000',
        fillOpacity: 0.35,
      })
      geofence.setMap(this.map)
    },
  },
  apollo: {
    getGeofencebyId: {
      query: GET_GEOFENCE_BY_ID,
      variables() {
        return {
          id: this.$route.params.id,
        }
      },
      result({ data }) {
        this.map.setCenter(data.getGeofencebyId.geofencePoint[0])
        this.map.setZoom(11)
        this.drawGeofence(data.getGeofencebyId.geofencePoint)
      },
      error(err) {
        console.log(err)
      },
      context: headers(),
    },
  },
  // eslint-disable-next-line vue/require-render-return
  render() {},
}
</script>
